import {
    defineStore,
} from 'pinia';
import {
    computed, reactive, toRefs,
} from 'vue';
import {
    createSoftSkill,
} from '../models/SoftSkill';

export const DEFAULT_SOFT_SKILL = {
    id: null,
    personalityTraitId: null,
};

export const useSoftSkillStore = defineStore('profile-soft-skills', () => {
    const state = reactive({
        softSkills: [],
    });

    function update({ personalityTraitId, softSkillId = null }) {
        if (
            state.softSkills.find(row => parseInt(row.personalityTraitId, 10) === parseInt(personalityTraitId, 10))
        ) {
            state.softSkills = state.softSkills
                .filter(row => !(parseInt(row.personalityTraitId, 10) === parseInt(personalityTraitId, 10)));
        } else {
            state.softSkills.push({
                id: softSkillId,
                personalityTraitId,
            });
        }
    }

    function updateFromQuery(data) {
        // The default row is merged to make sure all necessary fields are initialized.
        // eslint-disable-next-line no-param-reassign
        state.softSkills = data.map(softSkill => ({
            ...DEFAULT_SOFT_SKILL,
            id: softSkill.id,
            personalityTraitId: softSkill.personalityTraitId,
        }));
    }

    const models = computed(() => state.softSkills.map(x => createSoftSkill(x)));

    return {
        ...toRefs(state),
        update,
        updateFromQuery,
        models,
    };
});
